<template>
  <div class="intent-page">
    <!-- 顶部统计 -->
    <el-row :gutter="16" style="margin-bottom: 16px">
      <el-col :span="6">
        <el-card shadow="never">
          <div class="stat-card">
            <div class="stat-num" style="color:#f56c6c">{{ stats.A || 0 }}</div>
            <div class="stat-label">🔴 A级 强意向（可私信）</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="stat-card">
            <div class="stat-num" style="color:#e6a23c">{{ stats.B || 0 }}</div>
            <div class="stat-label">🟡 B级 弱意向（养熟）</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="stat-card">
            <div class="stat-num" style="color:#909399">{{ stats.C || 0 }}</div>
            <div class="stat-label">⚪ C级 无意向</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="stat-card">
            <div class="stat-num" style="color:#409eff">{{ total }}</div>
            <div class="stat-label">📝 意向评论总数</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <el-card shadow="never" style="margin-bottom: 16px">
      <div class="filter-bar">
        <el-select v-model="filterLevel" placeholder="等级筛选" size="small" clearable style="width: 130px" @change="loadData">
          <el-option label="A级 强意向" value="A" />
          <el-option label="B级 弱意向" value="B" />
          <el-option label="C级 无意向" value="C" />
        </el-select>
        <el-select v-model="filterBlogger" placeholder="博主筛选" size="small" clearable filterable style="width: 220px" @change="loadData">
          <el-option v-for="b in bloggers" :key="b" :label="b" :value="b" />
        </el-select>
        <el-button size="small" type="primary" :loading="loading" @click="loadData">🔄 刷新</el-button>
        <span class="hint">已覆盖 {{ bloggers.length }} 个博主 · A级建议优先处理</span>
      </div>
    </el-card>

    <!-- 评论表格 -->
    <el-card shadow="never">
      <el-table :data="comments" v-loading="loading" stripe>
        <el-table-column label="#" width="55" align="center">
          <template #default="{ row }">{{ row.seq }}</template>
        </el-table-column>
        <el-table-column label="意向等级" width="100" align="center">
          <template #default="{ row }">
            <el-tooltip :content="'命中: ' + (row.level_reason || '无')" placement="top">
              <el-tag :type="levelType(row.level)" size="small">{{ row.level }} · {{ row.level_label }}</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="来源博主" width="150">
          <template #default="{ row }">
            <el-link v-if="row.blogger_url" type="primary" :href="row.blogger_url" target="_blank">{{ row.blogger_name }}</el-link>
            <span v-else>{{ row.blogger_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户" width="140">
          <template #default="{ row }">
            <el-link v-if="row.profile_url" type="primary" :href="row.profile_url" target="_blank">{{ row.username }}</el-link>
            <span v-else>{{ row.username }}</span>
          </template>
        </el-table-column>
        <el-table-column label="评论内容" min-width="230" show-overflow-tooltip>
          <template #default="{ row }">
            <el-link v-if="row.video_url" :href="row.video_url" target="_blank" class="content-link">{{ row.content }}</el-link>
            <span v-else>{{ row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="采集时间" width="130">
          <template #default="{ row }">{{ row.scraped_at }}</template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template #default="{ row }">
            <el-tag :type="statusType(row.status)" size="small">{{ row.status_label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template #default="{ row }">
            <el-button size="small" type="success" :disabled="!row.profile_url" :loading="acting === 'follow:' + row.id" @click="doAction(row, 'follow')">关注</el-button>
            <el-button size="small" type="warning" :disabled="!row.profile_url" :loading="acting === 'comment:' + row.id" @click="doAction(row, 'comment')">留痕</el-button>
            <el-button size="small" type="danger" :disabled="!row.profile_url || row.level !== 'A'" :loading="acting === 'dm:' + row.id" @click="doAction(row, 'dm')">私信</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'IntentLeads',
  data() {
    return {
      loading: false,
      acting: '',
      stats: { A: 0, B: 0, C: 0 },
      total: 0,
      comments: [],
      bloggers: [],
      filterLevel: '',
      filterBlogger: ''
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    levelType(lv) {
      return { A: 'danger', B: 'warning', C: 'info' }[lv] || 'info'
    },
    statusType(st) {
      return { new: 'info', traced: 'success', followed: 'success', dm_sent: 'danger', dm_blocked: 'warning', skip: 'info' }[st] || 'info'
    },
    async loadData() {
      this.loading = true
      try {
        const params = {}
        if (this.filterLevel) params.level = this.filterLevel
        if (this.filterBlogger) params.blogger = this.filterBlogger
        const d = await api.get('/intent/intent-comments', { params })
        this.stats = d.stats || { A: 0, B: 0, C: 0 }
        this.total = d.total || 0
        this.comments = d.comments || []
        this.bloggers = d.bloggers || []
      } catch (e) {
        this.$message.error('加载失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    async doAction(row, action) {
      const key = action + ':' + row.id
      this.acting = key
      const text = action === 'comment'
        ? (['分析得很客观，已关注', '这前瞻真详细，学习到了', '博主对这场怎么看？', '讲得实在，支持', '每天必看你的前瞻'])[Math.floor(Math.random() * 5)]
        : action === 'dm'
          ? '你好，看你也玩竞彩，可以交流交流。我是实体彩票店的，有需要可以到店聊'
          : ''
      try {
        const r = await api.post('/intent/intent-comments/action', {
          comment_id: row.id,
          action,
          text
        })
        if (r.success) {
          this.$message.success(`操作成功：${r.detail}`)
        } else {
          this.$message.warning(`操作未成功：${r.detail}`)
        }
        this.loadData()
      } catch (e) {
        this.$message.error('操作失败: ' + e.message)
      } finally {
        this.acting = ''
      }
    }
  }
}
</script>

<style scoped>
.stat-card {
  text-align: center;
  padding: 8px 0;
}
.stat-num {
  font-size: 34px;
  font-weight: 800;
}
.stat-label {
  font-size: 13px;
  color: #666;
  margin-top: 6px;
}
.filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.hint {
  font-size: 13px;
  color: #999;
  margin-left: auto;
}
.content-link {
  color: #333;
}
.content-link:hover {
  color: #409eff;
}
</style>
